import { useEffect, useState } from "react";

/**
 * Desktop-only spotlight cursor — a tiny cyan dot with an expanding
 * ring over interactive elements (button, a, input, [role="button"]).
 * Hidden on touch / coarse pointers.
 */
export const SpotlightCursor = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const onMove = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      setVisible(true);
      const target = e.target;
      if (target && target.closest) {
        const match = target.closest("a, button, input, textarea, select, [role='button'], [data-cursor='hover']");
        setActive(Boolean(match));
      }
    };
    const onLeave = () => setVisible(false);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseleave", onLeave);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  if (!visible) return null;

  return (
    <>
      {/* Outer ring */}
      <div
        aria-hidden
        className="fixed top-0 left-0 pointer-events-none z-[70] rounded-full border border-cyan-400/60 mix-blend-difference"
        style={{
          width: active ? 44 : 22,
          height: active ? 44 : 22,
          transform: `translate(${pos.x - (active ? 22 : 11)}px, ${pos.y - (active ? 22 : 11)}px)`,
          transition: "width 200ms ease, height 200ms ease, border-color 200ms ease",
          boxShadow: active ? "0 0 16px rgba(0,229,255,0.5)" : "none",
        }}
      />
      {/* Inner dot */}
      <div
        aria-hidden
        className="fixed top-0 left-0 pointer-events-none z-[70] rounded-full bg-cyan-300"
        style={{
          width: 4,
          height: 4,
          transform: `translate(${pos.x - 2}px, ${pos.y - 2}px)`,
          boxShadow: "0 0 8px rgba(0,229,255,0.8)",
        }}
      />
    </>
  );
};

export default SpotlightCursor;
